import { ComponentStyleConfig } from '@chakra-ui/react';

import { COLORS } from '../../theme';

const TableTheme: ComponentStyleConfig = {
  parts: ['table', 'thead', 'tbody', 'tr', 'th', 'td', 'tfoot', 'caption'],
  baseStyle: {
    table: {},
    thead: {
      height: '40px',
      background: `${COLORS.silver.light}`,
      color: `${COLORS.black.lighter}`,

      tr: {
        th: {
          _first: {
            borderRadius: '8px 0px 0px 8px'
          },
          _last: {
            borderRadius: '0px 8px 8px 0px'
          }
        }
      }
    },
    tbody: {
      tr: {
        height: '56px',
        borderBottomWidth: `1px`,
        borderColor: `${COLORS.silver.light}`,
        _hover: {
          background: `${COLORS.silver.lighter}`
        },
        td: {
          border: 'none',
          color: `${COLORS.grey.base}`
        }
      }
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {
    variant: 'unstyled',
    colorScheme: undefined
  }
};

export default TableTheme;
